import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { PageMeta } from './PageMeta'
import { ShowcaseContentListItemDto } from './ShowcaseContentListItemDto'
/**
* Class PageOfShowcaseContentListItemDto
*  Результат постраничного запроса
*/
export class PageOfShowcaseContentListItemDto extends ActiveModel {

  /**
  * meta
  * Meta-информация о результате постраничного запроса  */
  @ActiveField({
    factory: [PageMeta, () => undefined]
  })
  meta?: PageMeta


/**
  * @property items
  * Список элементов страницы<br>  */
  @ActiveField({
    factory: [ShowcaseContentListItemDto, () => undefined]
  })
  items?: Array<ShowcaseContentListItemDto>
}
